export enum OrderStatus {
    Created = 0,
    InProduction = 1,
    Shipped = 2,
    Activated = 3,
    Cancelled = 4,
}

export enum EmailSendStatus {
  Unknown = 0,
  Deliverable = 1,
  Undeliverable = 2,
}
